/* MODALS */
import $ from 'jquery'
import loader from '../loader'

const modal = {
  ERROR_CLASS: 'modal--error',
  ERROR_MESSAGE_CLASS: 'modal__error-mssg',
  VISIBLE_CLASS: 'modal--visible',
  LOADING_CLASS: 'modal--loading',
  DEFAULT_TITLE: 'Untitled',
  TYPE_FLASH: 'flash',
  TYPE_IMG: 'img',
  OFFSET_TOP: 0,
  OFFSET_LEFT: 0,
  HEADER_HEIGHT: 0,
  ANIMATE_IN: 200,
  DEFAULT_HEIGHT: 500,

  /**
   * Loads an image into the DOM to first measure size before inserting into modal window.
   *
   * @param {object} $trigger
   */
  showImgModal($trigger) {
    loader.show()
    const $img = this.getImg($trigger)
    const title = this.getTitle($trigger)
    const index = this.getIndex($trigger)
    this.$body.addClass(this.LOADING_CLASS).append($img)
    const self = this
    $img.on('load', function() {
      loader.hide()
      const $this = $(this)
      const height = $this.height() + self.OFFSET_TOP
      const width = $this.width() + self.OFFSET_LEFT
      self.$modalBody.animate(
        {
          width,
          height,
        },
        self.ANIMATE_IN,
        () => {
          self.$modal.attr('data-index', index)
          self.$modal
            .find('.btn--modal-nav')
            .show()
            .height(height - self.HEADER_HEIGHT)
          self.clearModal()
          $this.attr('alt', title).appendTo(self.$modalTarget)
          self.$body.removeClass(`${self.LOADING_CLASS} ${self.ERROR_CLASS}`)
          self.$modalTitle.html(title)
          self.show()
          self.$modalBody.fadeIn()
        },
      )
    })

    $img.on('error', self.onImageLoadError.bind(self))
  },

  /**
   * Handle errors loading images.
   */
  onImageLoadError() {
    loader.hide()
    this.clearModal()
    this.$modal.find('.btn--modal-nav').height(200)
    this.$modalTitle.html('Something went wrong!')
    $('<p>')
      .addClass(this.ERROR_MESSAGE_CLASS)
      .text('Error loading image.')
      .appendTo(this.$modalTarget)
    this.$body.removeClass(this.LOADING_CLASS).addClass(this.ERROR_CLASS)
    this.show()
  },

  /**
   * Clear contents in modal
   */
  clearModal() {
    this.$modalTitle.html('')
    this.$modalTarget
      .find(`img, object, .${this.ERROR_MESSAGE_CLASS}`)
      .remove()
  },

  /**
   * Show flash modal.
   * @param {object} $trigger
   */
  showFlashModal($trigger) {
    const width = parseInt($trigger.attr('data-flash-width'), 10)
    const height = parseInt($trigger.attr('data-flash-height'), 10)
    const path = `/swf/${$trigger.attr('data-flash-name')}`

    const flashHtml = this.getFlashHtml(width, height, path)
    const title = this.getTitle($trigger)
    const index = this.getIndex($trigger)

    const self = this
    this.$modalBody.animate(
      {
        width: width + self.OFFSET_LEFT,
        height: height + self.OFFSET_TOP,
      },
      self.ANIMATE_IN,
      () => {
        self.$modal.attr('data-index', index)
        self.$modal.find('.btn--modal-nav').height(height - 2)
        self.$modalTarget.find('img, object').remove()
        self.$modalTarget.html(flashHtml)
        self.$body.removeClass(self.LOADING_CLASS)
        self.$modalTitle.html(title)
        self.show()
      },
    )
  },

  /**
   * Build html object string for flash items in modals.
   *
   * @param  {number} width
   * @param  {number} height
   * @param  {path} path
   *
   * @return {string}
   */
  getFlashHtml(width, height, path) {
    let html = `<object width="${width}" height="${height}">`
    html += '<param value="true" name="allowfullscreen">'
    html += '<param value="opaque" name="wmode">'
    html += '<param value="never" name="allowscriptaccess">'
    html += `<param value="${path}" name="movie">`
    html += `<embed width="${width}" height="${height}" allowscriptaccess="never" wmode="opaque" allowfullscreen="true" type="application/x-shockwave-flash" src="${path}">`
    return html
  },

  /**
   * Create image element for modal
   * @param  {object} $trigger
   * @return {object}
   */
  getImg($trigger) {
    return $('<img />').attr('src', $trigger.attr('data-media-url'))
  },

  /**
   * Builds title for modal
   * @param  {object} $trigger
   * @return string title
   */
  getTitle($trigger) {
    const title = $trigger.attr('data-title')
    return title || this.DEFAULT_TITLE
  },

  /**
   * Return the item's index
   * @param  {object} $trigger
   * @return {number}
   */
  getIndex($trigger) {
    return $trigger.attr('data-index')
  },

  /**
   * Show modal
   */
  show() {
    this.$body.addClass(this.VISIBLE_CLASS)
  },

  /**
   * Hide modal
   */
  hide() {
    this.$body.removeClass(this.VISIBLE_CLASS)
  },

  /**
   * Return a valid index so that we can keep looping through all items
   * on the page if we hit a boundary at either the first or last item.
   *
   * @param  {number} index - target index
   * @return {number} index - adjusted index
   */
  getValidIndex(index) {
    const total = this.$modalMediaThumbs.length - 1
    if (index < 0) {
      return total
    }
    if (index > total) {
      return 0
    }
    return index
  },

  /**
   * Load an item into modal by target index.
   * @param  {number} targetIndex
   */
  loadByIndex(targetIndex) {
    const validIndex = this.getValidIndex(targetIndex)
    if (this.modalType === this.TYPE_FLASH) {
      this.showFlashModal($(this.$modalMediaThumbs[validIndex]))
    } else {
      this.showImgModal($(this.$modalMediaThumbs[validIndex]))
    }
  },

  /**
   * Return modal type.
   * **Note: only works if all types on page are same. Change/improve if needed,
   * however since flash is a one off thing, should be fine.
   *
   * @return {string}
   */
  getModalType() {
    if (this.$modalMediaTriggers.attr('data-flash')) {
      return this.TYPE_FLASH
    }
    return this.TYPE_IMG
  },

  /**
   * Return current index of item in modal
   * @return {number}
   */
  getCurrentIndex() {
    return parseInt(this.$modal.attr('data-index'), 10) || 0
  },

  /**
   */
  bindEventHandlers() {
    const self = this

    self.$modalMediaTriggers.on('click', event => {
      event.preventDefault()
      if (self.modalType === self.TYPE_FLASH) {
        self.showFlashModal($(event.currentTarget))
      } else {
        self.showImgModal($(event.currentTarget))
      }
    })

    self.$soloModalMediaTriggers.on('click', event => {
      event.preventDefault()
      self.showImgModal($(event.currentTarget), true)
    })

    this.$modal.find('.modal__bg').on('click', self.hide.bind(self))

    this.$modal.find('.modal__close').on('click', event => {
      event.preventDefault()
      self.hide()
    })

    this.$modalTarget.on('click', () => {
      self.loadByIndex(self.getCurrentIndex() + 1)
    })

    this.$modal.find('.btn--modal-nav').on('click', function(event) {
      event.preventDefault()
      const adjustIndex = $(this).attr('data-direction') === 'prev' ? -1 : 1
      self.loadByIndex(self.getCurrentIndex() + adjustIndex)
    })

    this.$html.on('keydown', `body.${self.VISIBLE_CLASS}`, event => {
      const { keyCode } = event
      const disableNav = self.$body.hasClass(self.DISABLE_MODAL_NAV_CLASS)
      if (keyCode === 39 && !disableNav) {
        // right arrow
        self.loadByIndex(self.getCurrentIndex() + 1)
      } else if (keyCode === 37 && !disableNav) {
        // left arrow
        self.loadByIndex(self.getCurrentIndex() - 1)
      } else if (keyCode === 27) {
        // esc
        self.hide()
      }
    })
  },

  /**
   * Adjust sizing slightly of modal based on nav/header element sizing.
   * Cache header height which is used in sizing modal properly.
   */
  storePositions() {
    this.HEADER_HEIGHT = this.$modal.find('.modal__header').outerHeight()
    this.OFFSET_LEFT =
      this.$modal.find('.btn--modal-nav:first').outerWidth() * 2
    this.OFFSET_TOP = this.HEADER_HEIGHT + 20 // TODO: fix this, it's not quite right.
  },

  /**
   * Cache some elements and bind event handlers for modals
   */
  init() {
    this.$modalMediaTriggers = $('.modal-media-trigger')
    // solo functions the same as the $modalMediaTrigger except that there's no modal nav.
    this.$soloModalMediaTriggers = $('.solo-modal-media-trigger')
    this.$modalMediaThumbs = $('.modal-media-thumb').length
      ? $('.modal-media-thumb')
      : this.$modalMediaTriggers
    this.$modal = $('.modal')
    this.$modalTarget = this.$modal.find('.modal__body-content')
    this.$modalBody = this.$modal.find('.modal__content')
    this.$modalTitle = this.$modal.find('.modal__title')
    this.$body = $('body')
    this.$html = $('html')
    this.modalType = this.getModalType()
    this.storePositions()
    this.bindEventHandlers()
  },
}

export default modal
